import React from 'react';
import Notification from '../../../../components/Notification';
import { FormattedMessage } from 'react-intl';

const { id: module_id } = module;

const SetCloseContactNotification = () => {
  return (
    <div style={{ padding: '20px 20px 0 20px' }}>
      <Notification>
        <p style={{ margin: '0' }}>
          <FormattedMessage id={`${module_id}.content`} />
        </p>
      </Notification>
    </div>
  );
};

export default SetCloseContactNotification;
